import { Outlet } from 'react-router-dom';
import { NAV } from '../../lib/nav';
import { useAuth } from '../../lib/auth/AuthContext';
import { TopBar } from './TopBar';
import { BottomNav } from './BottomNav';
import { Sidebar } from './Sidebar';

export function AppShell() {
  const { ctx } = useAuth();
  const role = ctx?.user.role;
  const isKaprodi = ctx ? ctx.kaprodiProdiIds.length > 0 : false;
  const nav = role
    ? NAV[role].filter((item) => !(item.to === '/app/dosen/rekap' && !isKaprodi))
    : [];

  return (
    <div className="flex min-h-dvh">
      {/* Desktop navigation rail */}
      <Sidebar />

      {/* Content column */}
      <div className="flex min-w-0 flex-1 flex-col">
        <TopBar />

        <main className="flex-1 pb-24 md:pb-8">
          <div className="mx-auto w-full max-w-[1080px] px-4 md:px-8 md:pt-5">
            <Outlet />
          </div>
        </main>

        {/* Mobile bottom nav */}
        <BottomNav items={nav} />
      </div>
    </div>
  );
}
